import React, { Fragment, useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, FormGroup, RadioGroup } from '@tencent/spaui';

import Select from '../../../common/Select';
import Input from '../../../common/maxLengthInput';
import useInput from '../../../../leads_component/shared-components/hooks/useBasicInput';
import useSelect from '../../../../leads_component/shared-components/hooks/useSelect';

import { useInputMaxCharLengthPlugin } from '../../../../leads_component/shared-components/plugins/input-plugins';
import { genBasicHooks } from '../../../../leads_component/shared-components/plugins/helper';

import { OPERATION } from './config';
import RuleApplyRange from '../../../common/RuleApplyRange';
import useRuleApplyRange from '../../../hooks/useRuleApplyRange';

const Page = (props) => {
  const { industryList = [], talkList = [], model = 'add', data = {} } = props || {};

  const { id, name = '', industryCategoryId, callTalkId, variables = [], applyRange = {}, enabled } = data;

  const isLast = model == 'edit' && data.isLast;

  const nameHooks = genBasicHooks(useInput, { value: model == 'edit' ? name : '' }).usePlugin(
    useInputMaxCharLengthPlugin,
    { maxLength: 20 },
  );
  const industryHooks = useSelect({ data: industryList, value: model == 'edit' ? industryCategoryId : null });
  const talkHooks = useSelect({ data: [], value: model == 'edit' ? callTalkId : null });

  const [variableList, setVariableList] = useState([]);
  const [isEnabled, setEnabled] = useState(model == 'edit' ? enabled : true);

  const [mounted, setMounted] = useState(false);
  const [variablesMounted, setVariablesMounted] = useState(false);

  const applyRangeHooks = useRuleApplyRange({
    data: applyRange,
    model,
  });

  useEffect(() => {
    if (mounted) {
      talkHooks.setValue(null);
    }
    setMounted(true);
    if (industryHooks.props.value == null || industryHooks.props.value == '') {
      talkHooks.setData([]);
    } else {
      const _talkList = talkList.filter((e) => e.industryCategoryId == industryHooks.props.value);
      talkHooks.setData(_talkList);
    }
  }, [industryHooks.props.value]);

  useEffect(() => {
    if (talkHooks.props.value == null || talkHooks.props.value == '') {
      setVariableList([]);
    } else {
      let current = talkList.find(
        (e) => e.industryCategoryId == industryHooks.props.value && e.callTalkId == talkHooks.props.value,
      );

      current = current || { variables: [] };
      if (model == 'edit' && !variablesMounted) {
        setVariableList(
          current.variables.map((ele) => {
            const obj = variables.find((e) => e.name == ele.name);
            return {
              name: ele.name,
              cname: ele.cname,
              value: obj ? obj.value : '',
            };
          }),
        );
        setVariablesMounted(true);
      } else {
        setVariableList(current.variables);
      }
    }
  }, [talkHooks.props.value]);

  const onSubmit = () => {
    let canSubmit = true;

    if (nameHooks.props.value == null || nameHooks.props.value == '') {
      nameHooks.setError();
      canSubmit = false;
    }

    [industryHooks, talkHooks].forEach((e) => {
      if (e.props.value == null || e.props.value == '') {
        e.setValid(false);
        canSubmit = false;
      }
    });

    const _dataList = _.cloneDeep(variableList);
    variableList.forEach((e, index) => {
      if (e.value == null || e.value == '') {
        _dataList[index].valid = false;
        canSubmit = false;
      }
    });
    setVariableList(_dataList);

    if (!applyRangeHooks.checkValid()) {
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }

    const params = {
      name: nameHooks.props.value,
      industryCategoryId: industryHooks.props.value,
      callTalkId: talkHooks.props.value,
      variables: variableList,
      applyRange: isLast ? { applyRangeType: 'ELSE' } : applyRangeHooks.applyRange,
      enabled: isEnabled,
      status: model == 'edit' ? OPERATION.EDIT : OPERATION.NEW,
    };

    if (model == 'edit') {
      params.id = id;
    }

    if (props.onSubmit) {
      props.onSubmit(params);
    }
  };
  const renderIcon = () => {
    const avtive =
      industryHooks.props.value &&
      industryHooks.props.value != '' &&
      talkHooks.props.value &&
      talkHooks.props.value != '';
    return (
      <div
        className={avtive ? 'btn-audition action' : 'btn-audition'}
        onClick={() => {
          if (avtive) {
            handleClick();
          }
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g fill="CurrentColor" fillRule="nonzero">
            <path d="M14.913 12.96h.006v-.036l-.006.036zM12.41 1.44a.544.544 0 00-.296-.107c-.274 0-.494.236-.494.526 0 .21.117.377.282.472 1.814 1.125 3.034 3.212 3.034 5.605 0 2.39-1.219 4.477-3.03 5.602a.569.569 0 00-.297.48c0 .29.222.526.495.526.11 0 .196-.045.291-.104 2.106-1.305 3.522-3.728 3.522-6.504 0-2.77-1.41-5.188-3.507-6.496z" />
            <path d="M12.982 7.936c0-1.628-.831-3.048-2.067-3.813a.713.713 0 00-.28-.092c-.274 0-.496.236-.496.527 0 .196.097.37.246.462.955.576 1.6 1.666 1.6 2.916 0 1.272-.667 2.378-1.65 2.947a.535.535 0 00-.237.451c0 .292.222.529.496.529.116 0 .255-.072.255-.072 1.272-.754 2.133-2.197 2.133-3.855zM7.968.02L3.995 3.988v.006H.006v7.945h3.968l3.994 3.968h1.327V.02H7.968zM3.974 10.616H1.346V5.314h2.65v.007l3.972-3.978v13.24l-3.994-3.967z" />
          </g>
        </svg>
        试听
      </div>
    );
  };

  const onListChange = (index, value) => {
    const _dataList = _.cloneDeep(variableList);
    _dataList[index].value = value;
    _dataList[index].valid = true;
    setVariableList(_dataList);
  };

  const handleClick = () => {
    const current = talkList.find((e) => e.callTalkId == talkHooks.props.value);
    if (current) {
      new Audio(current.sampleAudioUrl).play();
    }
  };

  const renderVariables = () => {
    if (
      industryHooks.props.value &&
      industryHooks.props.value != '' &&
      talkHooks.props.value &&
      talkHooks.props.value != ''
    ) {
      if (variableList == undefined || variableList == null) {
        return null;
      }

      return variableList.map((e, index) => {
        const { name, cname, value, valid = true } = e || {};
        return (
          <Fragment>
            <em className="tt">{cname}</em>
            <div className="form-in">
              <Input
                placeholder={`请输入${cname}`}
                status={valid ? 'normal' : 'error'}
                maxLength={20}
                value={value}
                onChange={(e, value) => {
                  onListChange(index, value);
                }}
              />
            </div>
          </Fragment>
        );
      });
    }
    return null;
  };
  return (
    <div className="page-manage-set">
      <div className="panel">
        <div className="config-li">
          <em className="tt">规则名称</em>
          <div className="form-in">
            <Input {...nameHooks.props} disabled={isLast} />
          </div>
          <em className="tt">话术配置</em>
          <div className="form-in">
            <Select
              {...industryHooks.props}
              valueFieldName={'industryCategoryId'}
              labelFieldName={'industryCategoryName'}
            />
            <div className="audition">
              <Select
                placeholder="请选择话术"
                {...talkHooks.props}
                valueFieldName={'callTalkId'}
                labelFieldName={'callTalkName'}
              />
            </div>
            {renderIcon()}
          </div>
          {renderVariables()}
          <em className="tt">使用范围</em>
          <div className="form-in">
            <RuleApplyRange {...applyRangeHooks} disabled={isLast} />
          </div>
          <em className="tt">是否开启:（开启后，清洗规则生效）</em>
          <div className="form-in">
            <FormGroup>
              <RadioGroup
                data={[{ value: true, label: '是' }, { value: false, label: '否' }]}
                value={isEnabled}
                onChange={(e, value) => {
                  setEnabled(value);
                }}
              ></RadioGroup>
            </FormGroup>
          </div>
        </div>
      </div>
      <div className="btnline">
        <Button onClick={props.onCancel}>取消</Button>
        <Button bsStyle="primary" onClick={onSubmit}>
          提交
        </Button>
      </div>
    </div>
  );
};

export default Page;
